import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Svg3Cars = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 100,
	height: 50,
	viewBox: "50 100 540 210",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("style", { children: "\n    .greyColor {\n      fill: #eee !important;\n    }\n  " }),
		/* @__PURE__ */ _jsx("path", {
			d: "M69.4633 190.211C70.5467 193.029 80.7478 192.795 85.713 192.325C85.713 170.055 102.414 164.958 110.764 165.193C130.806 168.294 134.462 184.573 133.785 192.325H238.053C238.053 183.281 242.86 165.193 262.089 165.193C281.318 165.193 286.351 183.281 286.463 192.325C304.609 195.426 306.888 183.751 305.76 177.525C301.156 157.793 284.884 153.565 277.323 153.917C272.448 153.071 254.528 147.927 246.178 145.46C194.45 97.5389 117.648 120.795 85.713 138.413H72.1716C67.0259 138.413 65.2881 143.111 65.0624 145.46V158.498L61 165.193V179.287C61 183.516 66.6422 188.331 69.4633 190.211Z",
			stroke: "#5f5f5f",
			strokeWidth: 5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M108.733 147.575H161.206L157.482 125.376C142.248 122.909 117.874 135.242 108.733 140.175C101.421 144.121 105.687 146.752 108.733 147.575Z",
			stroke: "#5f5f5f",
			strokeWidth: 5,
			className: "greyColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M168.654 147.575L165.268 125.376C199.46 122.557 215.71 135.947 224.173 140.175C230.944 143.558 228.349 146.517 226.204 147.575H168.654Z",
			stroke: "#5f5f5f",
			strokeWidth: 5,
			className: "greyColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M126.545 190.563C126.545 200.565 118.78 208.5 109.41 208.5C100.04 208.5 92.2754 200.565 92.2754 190.563C92.2754 180.561 100.04 172.626 109.41 172.626C118.78 172.626 126.545 180.561 126.545 190.563Z",
			stroke: "#5f5f5f",
			strokeWidth: 5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M278.885 190.563C278.885 200.565 271.12 208.5 261.75 208.5C252.38 208.5 244.615 200.565 244.615 190.563C244.615 180.561 252.38 172.626 261.75 172.626C271.12 172.626 278.885 180.561 278.885 190.563Z",
			stroke: "#5f5f5f",
			strokeWidth: 5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M208.463 299.211C209.547 302.029 219.748 301.795 224.713 301.325C224.713 279.055 241.414 273.958 249.764 274.193C269.806 277.294 273.462 293.573 272.785 301.325H377.053C377.053 292.281 381.86 274.193 401.089 274.193C420.318 274.193 425.351 292.281 425.463 301.325C443.609 304.426 445.888 292.751 444.76 286.525C440.156 266.793 423.884 262.565 416.323 262.917C411.448 262.071 393.528 256.927 385.178 254.46C333.45 206.539 256.648 229.795 224.713 247.413H211.172C206.026 247.413 204.288 252.111 204.062 254.46V267.498L200 274.193V288.287C200 292.516 205.642 297.331 208.463 299.211Z",
			stroke: "#5f5f5f",
			strokeWidth: 5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M247.733 256.575H300.206L296.482 234.376C281.248 231.909 256.874 244.242 247.733 249.175C240.421 253.121 244.687 255.752 247.733 256.575Z",
			stroke: "#5f5f5f",
			strokeWidth: 5,
			className: "greyColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M307.654 256.575L304.268 234.376C338.46 231.557 354.71 244.947 363.173 249.175C369.944 252.558 367.349 255.517 365.204 256.575H307.654Z",
			stroke: "#5f5f5f",
			strokeWidth: 5,
			className: "greyColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M265.545 299.563C265.545 309.565 257.78 317.5 248.41 317.5C239.04 317.5 231.275 309.565 231.275 299.563C231.275 289.561 239.04 281.626 248.41 281.626C257.78 281.626 265.545 289.561 265.545 299.563Z",
			stroke: "#5f5f5f",
			strokeWidth: 5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M417.885 299.563C417.885 309.565 410.12 317.5 400.75 317.5C391.38 317.5 383.615 309.565 383.615 299.563C383.615 289.561 391.38 281.626 400.75 281.626C410.12 281.626 417.885 289.561 417.885 299.563Z",
			stroke: "#5f5f5f",
			strokeWidth: 5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M341.463 190.211C342.547 193.029 352.748 192.795 357.713 192.325C357.713 170.055 374.414 164.958 382.764 165.193C402.806 168.294 406.462 184.573 405.785 192.325H510.053C510.053 183.281 514.86 165.193 534.089 165.193C553.318 165.193 558.351 183.281 558.463 192.325C576.609 195.426 578.888 183.751 577.76 177.525C573.156 157.793 556.884 153.565 549.323 153.917C544.448 153.071 526.528 147.927 518.178 145.46C466.45 97.5389 389.648 120.795 357.713 138.413H344.172C339.026 138.413 337.288 143.111 337.062 145.46V158.498L333 165.193V179.287C333 183.516 338.642 188.331 341.463 190.211Z",
			stroke: "#5f5f5f",
			strokeWidth: 5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M380.733 147.575H433.206L429.482 125.376C414.248 122.909 389.874 135.242 380.733 140.175C373.421 144.121 377.687 146.752 380.733 147.575Z",
			stroke: "#5f5f5f",
			strokeWidth: 5,
			className: "greyColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M440.654 147.575L437.268 125.376C471.46 122.557 487.71 135.947 496.173 140.175C502.944 143.558 500.349 146.517 498.204 147.575H440.654Z",
			stroke: "#5f5f5f",
			strokeWidth: 5,
			className: "greyColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M398.545 190.563C398.545 200.565 390.78 208.5 381.41 208.5C372.04 208.5 364.275 200.565 364.275 190.563C364.275 180.561 372.04 172.626 381.41 172.626C390.78 172.626 398.545 180.561 398.545 190.563Z",
			stroke: "#5f5f5f",
			strokeWidth: 5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M550.885 190.563C550.885 200.565 543.12 208.5 533.75 208.5C524.38 208.5 516.615 200.565 516.615 190.563C516.615 180.561 524.38 172.626 533.75 172.626C543.12 172.626 550.885 180.561 550.885 190.563Z",
			stroke: "#5f5f5f",
			strokeWidth: 5
		})
	]
});
const ForwardRef = forwardRef(Svg3Cars);
export default ForwardRef;
